// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1mGk7","wrapper-nopadding":"wrapper-nopadding__1ILdp","loading":"loading__3r5JB","error":"error__ex-vW","table-loading":"table-loading__3AIL1","empty-val":"empty-val__1m55v","panelheader-tools":"panelheader-tools__PmRsI","propsPanels":"propsPanels__1x0CT","new":"new__1GxsF","marginLm":"marginLm__1KlW3","marginRm":"marginRm__128Ph","fullWidth":"fullWidth__2kagY","fullHeight":"fullHeight__23fEP","noData":"noData__3YaNx","infos":"infos__3P__G","info":"info__2EyZm"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Network/coms/ChannelView/coms/EditDRModal/styles.scss
// module id = 2291
// module chunks = 1